import {
    faAngleDown
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Card, Col, Container, Dropdown, Form, Image, Row, Table } from "react-bootstrap";
import { Image_Up, Man } from "../../../../../assets/images";
import * as Constants from "../../../../Helper/constants/constants";
import FiltersHeader from "../../../../Helper/filtersHeader";


const AddStaff = () => {
    var breadcrumData = ["Dashboard", "Manage Staff", "Staff List"];
    var breadcrumItem = "Add Staff Detail";

    return (
        <div className="add_staff_section">
            <FiltersHeader
                header={Constants.ADD_PROFILE}
                breadcrumData={breadcrumData}
                breadcrumItem={breadcrumItem}
            />
            <Container>
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="add_staff_area">
                            <div className="image_section">
                                <div className="img_area">
                                    <Image src={Man} alt="..." />
                                </div>
                                <div className="gallery_img">
                                    <Image src={Image_Up} alt="..." />
                                </div>
                            </div>
                            <div className="form_area">
                                <Form>
                                    <Form.Group className="form-group">
                                        <Form.Label>Full Name<span>*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Lauren"
                                        />
                                    </Form.Group>
                                    <Form.Group className="form-group">
                                        <Form.Label>Contact Number<span>*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="+91-7987987987"
                                        />
                                    </Form.Group>
                                    <Form.Group className="form-group">
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="harjinder12@gmail.com"
                                        />
                                    </Form.Group>
                                    <div className="dropdown_box">
                                        <h6>Hospital<span>*</span></h6>
                                        <div className="dropdown_area">
                                            <Dropdown>
                                                <Dropdown.Toggle id="dropdown-basic">
                                                    Select Hospital
                                                    <div className="icon down_icon ms-4">
                                                        <FontAwesomeIcon
                                                            icon={faAngleDown}
                                                        />
                                                    </div>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item href="javscript:;">
                                                        Indraprastha Apollo Hospital
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="javscript:;">
                                                        Fortis Escorts Hospital
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="javscript:;">
                                                        Manipal Hospitals
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="javscript:;">
                                                        Medanta Hospital
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="javscript:;">
                                                        Narayana Health Hospital
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                    <div className="dropdown_box">
                                        <h6>Specialization<span>*</span></h6>
                                        <div className="dropdown_area">
                                            <Dropdown>
                                                <Dropdown.Toggle id="dropdown-basic">
                                                    Viralogist
                                                    <div className="icon down_icon ms-4">
                                                        <FontAwesomeIcon
                                                            icon={faAngleDown}
                                                        />
                                                    </div>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item href="javscript:;">
                                                        Indraprastha Apollo Hospital
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="javscript:;">
                                                        Fortis Escorts Hospital
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="javscript:;">
                                                        Manipal Hospitals
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="javscript:;">
                                                        Medanta Hospital
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="javscript:;">
                                                        Narayana Health Hospital
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                    <Row>
                                        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
                                            <Form>
                                                <Form.Group className="form-group">
                                                    <Form.Label>Date of Birth<span>*</span></Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        placeholder="DD/MM/YYYY"
                                                    />
                                                    {/* <div className="icon_area">
                                                        <FontAwesomeIcon icon={faCalendarDays} />
                                                    </div> */}
                                                </Form.Group>
                                            </Form>
                                        </Col>
                                        <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12}>
                                            <div className="dropdown_box">
                                                <h6>Gender<span>*</span></h6>
                                                <div className="dropdown_area">
                                                    <Dropdown>
                                                        <Dropdown.Toggle id="dropdown-basic">
                                                            Male
                                                            <div className="icon down_icon ms-4">
                                                                <FontAwesomeIcon
                                                                    icon={faAngleDown}
                                                                />
                                                            </div>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item href="javscript:;">
                                                                Indraprastha Apollo Hospital
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="javscript:;">
                                                                Fortis Escorts Hospital
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="javscript:;">
                                                                Manipal Hospitals
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="javscript:;">
                                                                Medanta Hospital
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="javscript:;">
                                                                Narayana Health Hospital
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xxl={3} xl={3} lg={3} md={3} sm={12} xs={12}>
                                            <div className="dropdown_box">
                                                <h6>Blood Group</h6>
                                                <div className="dropdown_area">
                                                    <Dropdown>
                                                        <Dropdown.Toggle id="dropdown-basic">
                                                            AB+
                                                            <div className="icon down_icon ms-4">
                                                                <FontAwesomeIcon
                                                                    icon={faAngleDown}
                                                                />
                                                            </div>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item href="javscript:;">
                                                                Indraprastha Apollo Hospital
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="javscript:;">
                                                                Fortis Escorts Hospital
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="javscript:;">
                                                                Manipal Hospitals
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="javscript:;">
                                                                Medanta Hospital
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="javscript:;">
                                                                Narayana Health Hospital
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    {/* <div className="dropdown_box">
                                        <h6>Address<span>*</span></h6>
                                        <div className="dropdown_area">
                                            <Dropdown>
                                                <Dropdown.Toggle id="dropdown-basic">
                                                    Type here
                                                    <div className="icon down_icon ms-4">
                                                        <FontAwesomeIcon
                                                            icon={faAngleDown}
                                                        />
                                                    </div>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item href="javscript:;">
                                                        Indraprastha Apollo Hospital
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="javscript:;">
                                                        Fortis Escorts Hospital
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="javscript:;">
                                                        Manipal Hospitals
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="javscript:;">
                                                        Medanta Hospital
                                                    </Dropdown.Item>
                                                    <Dropdown.Item href="javscript:;">
                                                        Narayana Health Hospital
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div> */}

                                    <Form>
                                        <Form.Group className="form-group">
                                            <Form.Label>Address<span>*</span></Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Type here"
                                            />
                                            {/* <div className="icon_area">
                                                <FontAwesomeIcon icon={faCalendarDays} />
                                            </div> */}
                                        </Form.Group>
                                    </Form>
                                    <Row>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                            <div className="dropdown_box">
                                                <h6>City<span>*</span></h6>
                                                <div className="dropdown_area">
                                                    <Dropdown>
                                                        <Dropdown.Toggle id="dropdown-basic">
                                                            Select
                                                            <div className="icon down_icon ms-4">
                                                                <FontAwesomeIcon
                                                                    icon={faAngleDown}
                                                                />
                                                            </div>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item href="javscript:;">
                                                                Indraprastha Apollo Hospital
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="javscript:;">
                                                                Fortis Escorts Hospital
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="javscript:;">
                                                                Manipal Hospitals
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="javscript:;">
                                                                Medanta Hospital
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="javscript:;">
                                                                Narayana Health Hospital
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                                            <div className="dropdown_box">
                                                <h6>State<span>*</span></h6>
                                                <div className="dropdown_area">
                                                    <Dropdown>
                                                        <Dropdown.Toggle id="dropdown-basic">
                                                            Select
                                                            <div className="icon down_icon ms-4">
                                                                <FontAwesomeIcon
                                                                    icon={faAngleDown}
                                                                />
                                                            </div>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            <Dropdown.Item href="javscript:;">
                                                                Indraprastha Apollo Hospital
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="javscript:;">
                                                                Fortis Escorts Hospital
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="javscript:;">
                                                                Manipal Hospitals
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="javscript:;">
                                                                Medanta Hospital
                                                            </Dropdown.Item>
                                                            <Dropdown.Item href="javscript:;">
                                                                Narayana Health Hospital
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Form>
                                <div className="add_role_screen">
                                    <div className="add_role_details">
                                        <div className="title_btn_area">
                                            <div className="left_area">
                                                <Form.Check
                                                    reverse
                                                    type="checkbox"
                                                    id="Critical"
                                                    label="User  is Super Admin"
                                                />
                                            </div>
                                            <div className="right_area">
                                                <Form.Check
                                                    reverse
                                                    type="checkbox"
                                                    id="Critical"
                                                    label="Select all"
                                                />
                                            </div>
                                        </div>
                                        <div className="list_detail">
                                            <div className="list_data">
                                                <Card>
                                                    <Card.Body>
                                                        <h4>User Permission </h4>
                                                        <Table responsive>
                                                            <tr>
                                                                <th>
                                                                    <ul className="list-inline">
                                                                        <li className="fix-area">Module</li>
                                                                        <li className="list-gap">Listing</li>
                                                                        <li className="list-gap">Create</li>
                                                                        <li className="list-gap">Update</li>
                                                                        <li className="list-gap">Delete</li>
                                                                    </ul>
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <ul className="list-inline">
                                                                        <li className="fix-area">Doctor</li>

                                                                        <li>
                                                                            <Form.Check
                                                                                reverse
                                                                                type="checkbox"
                                                                                id="Critical"
                                                                                // label="Lorem"
                                                                                className="check_icon"
                                                                            />
                                                                        </li>
                                                                        <li className="list-gap">
                                                                            <Form.Check
                                                                                reverse
                                                                                type="checkbox"
                                                                                id="Critical"
                                                                            // label="Lorem"
                                                                            />
                                                                        </li>
                                                                        <li className="list-gap">
                                                                            <Form.Check
                                                                                reverse
                                                                                type="checkbox"
                                                                                id="Critical"
                                                                            // label="Lorem"
                                                                            />
                                                                        </li>
                                                                        <li className="list-gap">
                                                                            <Form.Check
                                                                                reverse
                                                                                type="checkbox"
                                                                                id="Critical"
                                                                            // label="Lorem"
                                                                            />
                                                                        </li>
                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <ul className="list-inline">
                                                                        <li className="fix-area">Nurse</li>

                                                                        <li>
                                                                            <Form.Check
                                                                                reverse
                                                                                type="checkbox"
                                                                                id="Critical"
                                                                                // label="Lorem"
                                                                                className="check_icon"
                                                                            />
                                                                        </li>
                                                                        <li className="list-gap">
                                                                            <Form.Check
                                                                                reverse
                                                                                type="checkbox"
                                                                                id="Critical"
                                                                            // label="Lorem"
                                                                            />
                                                                        </li>
                                                                        <li className="list-gap">
                                                                            <Form.Check
                                                                                reverse
                                                                                type="checkbox"
                                                                                id="Critical"
                                                                            // label="Lorem"
                                                                            />
                                                                        </li>
                                                                        <li className="list-gap">
                                                                            <Form.Check
                                                                                reverse
                                                                                type="checkbox"
                                                                                id="Critical"
                                                                            // label="Lorem"
                                                                            />
                                                                        </li>
                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <ul className="list-inline">
                                                                        <li className="fix-area">Lab</li>

                                                                        <li>
                                                                            <Form.Check
                                                                                reverse
                                                                                type="checkbox"
                                                                                id="Critical"
                                                                                // label="Lorem"
                                                                                className="check_icon"
                                                                            />
                                                                        </li>
                                                                        <li className="list-gap">
                                                                            <Form.Check
                                                                                reverse
                                                                                type="checkbox"
                                                                                id="Critical"
                                                                            // label="Lorem"
                                                                            />
                                                                        </li>
                                                                        <li className="list-gap">
                                                                            <Form.Check
                                                                                reverse
                                                                                type="checkbox"
                                                                                id="Critical"
                                                                            // label="Lorem"
                                                                            />
                                                                        </li>
                                                                        <li className="list-gap">
                                                                            <Form.Check
                                                                                reverse
                                                                                type="checkbox"
                                                                                id="Critical"
                                                                            // label="Lorem"
                                                                            />
                                                                        </li>
                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td>
                                                                    <ul className="list-inline">
                                                                        <li className="fix-area">Admin</li>

                                                                        <li>
                                                                            <Form.Check
                                                                                reverse
                                                                                type="checkbox"
                                                                                id="Critical"
                                                                                // label="Lorem"
                                                                                className="check_icon"
                                                                            />
                                                                        </li>
                                                                        <li className="list-gap">
                                                                            <Form.Check
                                                                                reverse
                                                                                type="checkbox"
                                                                                id="Critical"
                                                                            // label="Lorem"
                                                                            />
                                                                        </li>
                                                                        <li className="list-gap">
                                                                            <Form.Check
                                                                                reverse
                                                                                type="checkbox"
                                                                                id="Critical"
                                                                            // label="Lorem"
                                                                            />
                                                                        </li>
                                                                        <li className="list-gap">
                                                                            <Form.Check
                                                                                reverse
                                                                                type="checkbox"
                                                                                id="Critical"
                                                                            // label="Lorem"
                                                                            />
                                                                        </li>
                                                                    </ul>
                                                                </td>
                                                            </tr>
                                                        </Table>
                                                    </Card.Body>
                                                </Card>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="btn_area">
                                    <Button className="cancelBtn" type="button" >Cancel</Button>
                                    <Button className="submitBtn" type="submit">Submit</Button>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            {/* <DeleteModal /> */}
        </div >
    );
};

export default AddStaff;
